<template>
    <div class="col-12 col-lg-3 d-flex">
        <div class="account-nav flex-grow-1">
            <h4 class="account-nav__title">Navigation</h4>
            <ul class="account-nav__list">
                <li class="account-nav__item" :class="[activePage === 'account-summary' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-summary">Account Summary</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'order-history' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-orders">Order History</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'invoices-open' ? 'account-nav__item--active' : '']">
                    <router-link to="/invoices-open">Open Invoices</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'open-orders' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-open-orders">Open Orders</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === '/invoices-paid' ? 'account-nav__item--active' : '']">
                    <router-link to="/invoices-paid">Paid Invoices</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'return-list' ? 'account-nav__item--active' : '']">
                    <router-link to="/return-list">Return History</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'account-search' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-search">Search Invoices and Payments</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'shipped-orders' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-shipped-orders">Shipped Orders</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'account-statements' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-statements">Statements</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'saved-payment-methods' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-saved-payment-methods">Your Saved Payment Methods</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'saved-qwik-orders' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-saved-qwik-orders">Your Saved Qwik Orders</router-link>
                </li>
                <li class="account-nav__item" v-if="has_saved_vehicles" :class="[activePage === 'account-garage' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-garage">Your Saved Vehicles</router-link>
                </li>
                <li class="account-nav__item" :class="[activePage === 'account-addresses' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-addresses">Edit Profile and Addresses</router-link>
                </li>
                <li class="account-nav__item">
                    <a href='#' @click="openDocuments()">Documents</a>
                </li>
                <li class="account-nav__item" :class="[activePage === 'account-password' ? 'account-nav__item--active' : '']">
                    <router-link to="/account-password">Password</router-link>
                </li>

                
                <li class="account-nav__divider" role="presentation"></li>
                <!-- <li class="account-nav__item">
                    <router-link to="/login">Logout</router-link>
                </li> -->
            </ul>
        </div>
    </div>

    <base-dialog title="Documents" :newClass="newClass" @close="openDocumentDialog = false" :open="openDocumentDialog == true">
        <template #default>
            <iframe :src="document_src"></iframe>
        </template>
        <template #actions>
        <button type="button" class="btn btn-sm btn-primary" @click="openDocumentDialog = false">
            Ok
        </button>
        </template>
    </base-dialog>

</template>

<script>
    import axiosvl from "../../../axios/axios-vl.js";
    import { mapGetters } from 'vuex';
    // import { sfCustom } from '../../../utilities/customs';

    export default {
        props: {
            activePage: {
                type: String,
                required: true
            },
        },
        computed: {
            ...mapGetters(['userIsAuthenticated', 'storefront']),
            
            document_src() {
                return 'http://130.250.177.157/cgi-doc/qointer.pgm?custkey=' + this.custKey;
            },

            has_saved_vehicles() {
                if(this.storefront){
                    // return sfCustom[this.storefront].saved_vehicles;
                    return process.env.VUE_SAVED_VEHICLES;
                }
                return false;
            },
        },
        data() {
            return {
                openDocumentDialog : false,
                custKey : null,
                newClass : 'dialog-lg'
            }
        },
        methods: {
            openDocuments() {
                this.openDocumentDialog = true;
                // alert('document');
            },
            getCustomerInfo() {
                axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                        }
                    }
                })
                .then((response) => {
                    const fields = response.data.webroutine.fields
                    this.custKey = fields.CUSTKEY.value;
                })
                .catch((error) => {
                    this.isloading = false;
                    console.error("error - " + error);
                });
            },
        },

        created() {
            this.getCustomerInfo();
        }
        
    }
</script>

<style>
    dialog.dialog-lg {
        width: 80% !important;
        height: 80% !important;
    }

    dialog section.dialog-body {
        height: 80%;
    }

    iframe {
        width: 100%;
        height: 100%;
    }
</style>